import * as React from "react";
import { useI18n } from "../domain/i18n";
import KVListComponent from "./KVListComponent";

export interface SocialMediaToolbarProps {
  tabKey: any;
  links: any;
}

export const SocialMediaToolbar = ({ tabKey, links }: SocialMediaToolbarProps) => {
  const I18n = useI18n();
  return (
    <div>
      <KVListComponent
        tabKey={tabKey}
        items={[
          {
            key: I18n.t("frontend.social-media.subscribe.label"),
            value: (
              <a href={links.rss} target="_blank" rel="noreferrer" className="button button--inline button--secondary">
                <i className="icon-feed" />
                <span>{" " + I18n.t("frontend.social-media.subscribe.rss")}</span>
              </a>
            ),
          },
          {
            key: I18n.t("frontend.social-media.follow.label"),
            value: (
              <a
                href="https://www.facebook.com/publicvalueresearch"
                target="_blank"
                rel="noreferrer"
                className="button button--inline button--secondary mls"
              >
                <i className="icon-facebook" />
                <span>{" " + I18n.t("frontend.social-media.follow.facebook")}</span>
              </a>
            ),
          },
        ]}
      />
    </div>
  );
};

export default SocialMediaToolbar;
